export const DISEASE_GET_REQUEST = 'DISEASE_GET_REQUEST';
export const DISEASE_GET_SUCCESS = 'DISEASE_GET_SUCCESS';
export const DISEASE_GET_ERROR = 'DISEASE_GET_ERROR';
export const DISEASE_GET_BY_KEY_REQUEST = 'DISEASE_GET_BY_KEY_REQUEST';
export const DISEASE_GET_BY_KEY_SUCCESS = 'DISEASE_GET_BY_KEY_SUCCESS';
export const DISEASE_GET_BY_KEY_ERROR = 'DISEASE_GET_BY_KEY_ERROR';
export const DISEASE_ADD_REQUEST = 'DISEASE_ADD_REQUEST';
export const DISEASE_ADD_SUCCESS = 'DISEASE_ADD_SUCCESS';
export const DISEASE_ADD_ERROR = 'DISEASE_ADD_ERROR';
export const DISEASE_EDIT_REQUEST = 'DISEASE_EDIT_REQUEST';
export const DISEASE_EDIT_SUCCESS = 'DISEASE_EDIT_SUCCESS';
export const DISEASE_EDIT_ERROR = 'DISEASE_EDIT_ERROR';
export const DISEASE_DELETE_REQUEST = 'DISEASE_DELETE_REQUEST';
export const DISEASE_DELETE_SUCCESS = 'DISEASE_DELETE_SUCCESS';
export const DISEASE_DELETE_ERROR = 'DISEASE_DELETE_ERROR';
